import { computed } from "vue";
import { logEvent } from "~/utils/firebase";

const PAGE_NAME = "mentor_list";
const DEFAULT_MENTOR_TYPE = "normal";
const VALID_MENTOR_TYPES = ["normal", "famous"];

function normalizeMentorType(mentorType) {
	return VALID_MENTOR_TYPES.includes(mentorType) ? mentorType : DEFAULT_MENTOR_TYPE;
}

function getEntrySource() {
	if (!import.meta.client) return "direct";
	const referrer = document.referrer;
	if (!referrer) return "direct";
	try {
		const referrerUrl = new URL(referrer);
		if (referrerUrl.host === window.location.host) return "internal";
		return referrerUrl.host;
	} catch {
		return "unknown";
	}
}

function getLoginStatus() {
	if (!import.meta.client) return "guest";
	try {
		const hasToken = !!localStorage.getItem("token");
		if (hasToken) return "logged_in";
		const gwUser = localStorage.getItem("gwUser");
		return gwUser && gwUser !== "{}" ? "logged_in" : "guest";
	} catch {
		return "guest";
	}
}

function cleanParams(params) {
	return Object.fromEntries(
		Object.entries(params).filter(
			([, value]) => value !== undefined && value !== null && value !== ""
		)
	);
}

export function getPriceBucket(value) {
	const price = Number(String(value ?? "").replace(/[^\d.]/g, ""));
	if (!Number.isFinite(price) || price <= 0) return "0";
	if (price <= 99) return "1-99";
	if (price <= 499) return "100-499";
	if (price <= 999) return "500-999";
	return "1000+";
}

export function getConsultationCountBucket(value) {
	const count = Number(value || 0);
	if (!Number.isFinite(count) || count < 0) return "0-99";
	if (count <= 99) return "0-99";
	if (count <= 999) return "100-999";
	if (count <= 9999) return "1k-9k";
	return "10k+";
}

export function normalizeMentorRating(value) {
	const score = Number(value || 0);
	if (!Number.isFinite(score) || score <= 0) return 5;
	return Number(Math.min(score, 5).toFixed(1));
}

export function getMentorTypeByAreaType(areaType) {
	return Number(areaType) === 10 ? "famous" : "normal";
}

export function useMentorListTracking(options = {}) {
	const deviceType = options?.deviceType || "pc";
	const mentorType = normalizeMentorType(options?.mentorType);

	const baseParams = computed(() =>
		cleanParams({
			page_name: PAGE_NAME,
			entry_source: getEntrySource(),
			login_status: getLoginStatus(),
			device_type: deviceType,
		})
	);

	function track(eventName, params = {}) {
		logEvent(eventName, cleanParams({ ...baseParams.value, mentor_type: mentorType, ...params }));
	}

	return {
		track,
		baseParams,
		mentorType,
	};
}
